module.exports = __webpack_public_path__ + "e22b799af432c9215075395379e16259.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/cloche.svg
// module id = 741
// module chunks = 0